module.exports = __webpack_public_path__ + "static/media/Josh,18@2x.ee17792b.png";